import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import commentsPlugin from "../Plugins/comments.plugin";
import DialogContributorCommentEditor from "../../Dialogs/DialogContributorCommentEditor";
import { useSupabaseSession } from "../../../../../utils/AuthSessionProvider";

export default function CommentsConsole() {
  const { user } = useSupabaseSession();

  return (
    <ConsolePageFrame
      title="Contributor Comments"
      plugin={commentsPlugin}
      searchPlaceholder="Search (username / content)"
      addButtonLabel="Add Comment"
      renderAddDialog={({ onClose }) => (
        <DialogContributorCommentEditor
          open
          mode="add"
          user={user}
          onClose={onClose}
        />
      )}
      renderEditDialog={({ row, onClose }) => (
        <DialogContributorCommentEditor
          open
          mode="edit"
          comment={row}
          user={user}
          onClose={onClose}
        />
      )}
      toastMessages={{ create: "Comment created", update: "Comment updated" }}
      initialPageSize={50}
      getRowId={(row) => row.id}
    />
  );
}
